export default "__VITE_ASSET__12R1N4yL__"